import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetBuildings_buildingIdCardExportXlsx = z.any()
export type TagsGetBuildings_buildingIdCardExportXlsx = z.infer<typeof tagsGetBuildings_buildingIdCardExportXlsx>

export const paramsGetBuildings_buildingIdCardExportXlsx = z.object({ "buildingId": z.string().uuid() })
export type ParamsGetBuildings_buildingIdCardExportXlsx = z.infer<typeof paramsGetBuildings_buildingIdCardExportXlsx>

export const responseGetBuildings_buildingIdCardExportXlsx = z.any()
export type ResponseGetBuildings_buildingIdCardExportXlsx = z.infer<typeof responseGetBuildings_buildingIdCardExportXlsx>

interface IGetBuildings_buildingIdCardExportXlsx extends BaseMethodType {
  tags: TagsGetBuildings_buildingIdCardExportXlsx,
  params: ParamsGetBuildings_buildingIdCardExportXlsx,
  response: ResponseGetBuildings_buildingIdCardExportXlsx
}
export const URL = '/buildings/:buildingId/card/export/xlsx'
export const validation = {
  get: {
    tags: tagsGetBuildings_buildingIdCardExportXlsx,
    params: paramsGetBuildings_buildingIdCardExportXlsx,
    response: responseGetBuildings_buildingIdCardExportXlsx
  }
}
export interface Buildings_buildingIdCardExportXlsx extends BaseRouteType {
  get: IGetBuildings_buildingIdCardExportXlsx
}